// extracted by mini-css-extract-plugin
export var activeDot = "_3d-c";
export var buttonContainer = "_3d-9";
export var channelButton = "_3d-a";
export var clickable = "_3d-d";
export var content = "_3d-0";
export var contentFull = "_3d-2";
export var contentThird = "_3d-1";
export var contentWrapper = "_3d-7";
export var description = "_3d-5";
export var heightShort = "_3d-f";
export var image = "_3d-3";
export var imageContainer = "_3d-4";
export var selectButton = "_3d-e";
export var spinnerContainer = "_3d-b";
export var titleContent = "_3d-8";
export var titleWrapper = "_3d-6";